import { createSlice } from "@reduxjs/toolkit";
import { ITravelPlanRate, IShelfPlanAdminCost, IShelfPlanInformation } from "components/travel/shelfPlans/information/Information.interface";
import { ITravelPlanServiceRateConfiguration } from "container/travel/planSetup/b2c/shelfPlans/services/shelfPlanService.interface";
import { RootState } from "redux/store";
import { SALE_POINTS } from "shared/constant";
import { IListOfValues } from "shared/interface/types";

interface ITravelInitialState {
  ShelfPlan: IShelfPlanInformation;
  ActivePriceSalePoint: keyof typeof SALE_POINTS;
  ShelfPlanAdminCost: IShelfPlanAdminCost;
  TravelPlanRateConfiguration: ITravelPlanRate[];
  TravelPlanActivePlans: string[];
  TravelPlanService: {
    id: string;
    travelPlanServiceRateConfiguration?: ITravelPlanServiceRateConfiguration[];
    service?: { contribution: IListOfValues; id: number; name: string };
  };
}
const initialState: ITravelInitialState = {
  ShelfPlan: {
    travelPlanGenders: [],
    isStudentPlan: true,
    planTypeId: 0,
    priceTypeId: 0,
    id: "",
    takafulProviderId: 0,
    tripType: 0,
    groupType: [],
    productName: "",
    salePoint: [],
    renewalMinAge: 0,
    renewalMaxAge: 0
  },
  TravelPlanService: {
    id: ""
  },
  ActivePriceSalePoint: "",
  ShelfPlanAdminCost: {
    adminCostMax: 0,
    adminCostMaxTypeId: 0,
    adminCostMin: 0,
    adminCostMinTypeId: 0
  },
  TravelPlanRateConfiguration: [],
  TravelPlanActivePlans: []
};

const travelSlice = createSlice({
  name: "travel",
  initialState,
  reducers: {
    AddTravelShelfPlan: (state, action) => {
      state.ShelfPlan = action.payload;
    },
    AddTravelPlanService: (state, action) => {
      state.TravelPlanService = action.payload;
    },
    DeleteTravelShelfPlan: state => {
      state.ShelfPlan = initialState.ShelfPlan;
    },
    UpdateActiveSalePoint: (state, action) => {
      state.ActivePriceSalePoint = action.payload;
    },
    UpdateAdminCostForShelfPlanPrice: (state, action) => {
      state.ShelfPlanAdminCost = action.payload;
    },
    UpdateTravelPlanRateConfiguration: (state, action) => {
      state.TravelPlanRateConfiguration = action.payload;
    },
    UpdateTravelActivePlan: (state, action) => {
      state.TravelPlanActivePlans = action.payload;
    }
  }
});

export const {
  AddTravelShelfPlan,
  DeleteTravelShelfPlan,
  UpdateActiveSalePoint,
  UpdateAdminCostForShelfPlanPrice,
  UpdateTravelPlanRateConfiguration,
  UpdateTravelActivePlan,
  AddTravelPlanService
} = travelSlice.actions;
export default travelSlice.reducer;

export const getTravelShelfPlan = (state: RootState): ITravelInitialState => state.travel;
